import { render, staticRenderFns } from "./UdsHome.vue?vue&type=template&id=5fcb314c&scoped=true&"
import script from "./UdsHome.vue?vue&type=script&lang=js&"
export * from "./UdsHome.vue?vue&type=script&lang=js&"
import style0 from "./UdsHome.vue?vue&type=style&index=0&id=5fcb314c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb314c",
  null
  
)

export default component.exports